import React from 'react';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from '../../../utils/hooks/useDateService';
import useFieldHelper from '../fieldHelper';
import TextField from '../text/TextField';
import { FieldProps } from '../types';

const DateField = ({ dateFormat, className, ...props }: FieldProps & { dateFormat?: string }) => {
  const { getValue, getLabel } = useFieldHelper(props);

  return (
    <TextField
      label={getLabel()}
      value={
        getValue() ? (
          <ShowDate dateUTC={getValue()} format={dateFormat || DATE_FORMAT.SIMPLE} isDateTime={false} />
        ) : null
      }
      className={className}
    />
  );
};

export default DateField;
